module.exports = __webpack_public_path__ + "static/digma-e0fdfba77c4621c3a64305a6484b3937.jpg";